/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiAnalyticEventVignetteDrawerExpandedFromJSON(json) {
    return StreemApiAnalyticEventVignetteDrawerExpandedFromJSONTyped(json, false);
}
export function StreemApiAnalyticEventVignetteDrawerExpandedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'vignettElementId': !exists(json, 'vignett_element_id') ? undefined : json['vignett_element_id'],
        'finishId': !exists(json, 'finish_id') ? undefined : json['finish_id'],
        'snapPoint': !exists(json, 'snap_point') ? undefined : json['snap_point'],
    };
}
export function StreemApiAnalyticEventVignetteDrawerExpandedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'vignett_element_id': value.vignettElementId,
        'finish_id': value.finishId,
        'snap_point': value.snapPoint,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiAnalyticEventVignetteDrawerExpandedSnapPoint;
(function (StreemApiAnalyticEventVignetteDrawerExpandedSnapPoint) {
    StreemApiAnalyticEventVignetteDrawerExpandedSnapPoint["FULLHEIGHT"] = "SNAP_POINT_FULL_HEIGHT";
    StreemApiAnalyticEventVignetteDrawerExpandedSnapPoint["HALFEXTENDED"] = "SNAP_POINT_HALF_EXTENDED";
    StreemApiAnalyticEventVignetteDrawerExpandedSnapPoint["INVALID"] = "SNAP_POINT_INVALID";
    StreemApiAnalyticEventVignetteDrawerExpandedSnapPoint["PEEKHEIGHT"] = "SNAP_POINT_PEEK_HEIGHT";
})(StreemApiAnalyticEventVignetteDrawerExpandedSnapPoint || (StreemApiAnalyticEventVignetteDrawerExpandedSnapPoint = {}));
//# sourceMappingURL=StreemApiAnalyticEventVignetteDrawerExpanded.js.map